export const FREE_POSTAL = 'free_postal'; // billing plan code
export const FREE_STARTER = 'free_starter'; // billing plan code
export const SQUARE_LOGIN_URL = 'https://squareup.com/login';

// Shipment limit codes
export const LIMIT_UNCHANGED = 'LimitUnchanged';
export const LIMIT_HIGH_VOLUME_SHIPMENTS = 'LimitHighVolumeShipments';
export const LIMIT_HIGH_VOLUME_SHIPMENTS_15 = 'LimitHighVolumeShipments15';
export const LIMIT_HIGH_VOLUME_SHIPMENTS_8 = 'LimitHighVolumeShipments8';
export const LIMIT_10K_PLUS = 'Limit10KPlus';
export const LIMIT_10_PLUS = 'Limit10Plus';

// ChangePlan error codes
export const INSUFFICIENT_PLAN_RESOURCES = 'InsufficientPlanResources';
export const NO_BILLING_INFO = 'NoBillingInfo';
export const CARD_DECLINED = 'CardDeclined';
export const FAILED_UPDATE_PBS_BILLING_INFO = 'FailedUpdatePBSBillingInfo';

export const SQUARE_BILLING_PROVIDER_ID = 3;
export const COST_PER_SHIPMENT_OVER_10K_USD = '1.4¢';
export const COST_PER_SHIPMENT_15_USD = '1.5¢';
export const COST_PER_SHIPMENT_OVER_10K_GBP = '1p';
export const COST_PER_SHIPMENT_OVER_10K_EUR = '1c';

export const CANCEL_ACCOUNT_PAGE = 1;
export const CANCEL_STAMPS_ACCOUNT_PAGE = 2;
export const CANCEL_ACCOUNT_VIA_SUPPORT = 3;

export const STAMPS_CORE_PLAN_PRICE = '$20.99';
export const STAMPS_CORE_PLAN_ID = 380; // keep in sync with StampsPlansThatSurviveSsCancellationBillingPlanId in backend
export const SHORT_ANSWER_QUESTION = '1';
export const DROPDOWN_QUESTION = '2';
export const OTHER_CANCEL_REASON_ID = '7';
export const DEFAULT_CANCEL_REASON_ID = '0';

export const PlanSimplificationExperimentVariants = {
  NOTENROLLED: '0',
  CONTROL: '1',
  VARIANT: '2',
};
